import _styled from "@emotion/styled-base";

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

import { css } from "@emotion/core";
import * as React from "react";
import { ChevronLeft, ChevronRight } from "react-feather";
import tinycolor from "tinycolor2";
import { em, emRhythm } from "../css";
import { jsx as ___EmotionJSX } from "@emotion/core";
var ENTER = 13;
var SPACE = 32;

var NavIcon = _styled("svg", {
  target: "e11m763h0"
})({
  name: "wu75jt",
  styles: "position:relative;top:0.09em;"
});

var NavLeftIcon = NavIcon.withComponent(ChevronLeft, {
  target: "e11m763h3"
});
var NavRightIcon = NavIcon.withComponent(ChevronRight, {
  target: "e11m763h4"
});

var NavBar = _styled("div", {
  target: "e11m763h1"
})("position:absolute;top:", emRhythm(0.125), ";right:", emRhythm(0.375), ";"); // eslint-disable-next-line @typescript-eslint/ban-types


var NavButton = _styled("button", {
  target: "e11m763h2"
})(function (_ref) {
  var theme = _ref.theme;
  return /*#__PURE__*/css("position:relative;font-size:24px;width:", em(36, 24), ";height:", em(36, 24), ";padding:0;cursor:pointer;background:white;border:0;color:", theme.colors.muted, ";border-radius:100%;z-index:1;transition:all 250ms ease-out;&:focus{transition-duration:100ms;outline:none;box-shadow:0px 0px 2px 2px ", tinycolor(theme.colors.blue).setAlpha(0.5).toString(), ";}&:focus,&:hover{transition-duration:100ms;background:", theme.colors.grays[50], ";color:", theme.colors.heading, ";z-index:2;}&:disabled{cursor:default;background:transparent;color:", theme.colors.border, ";}");
}); // This is a customized NavBar that uses <button>s and Icons that fit our
// design system. See the original file for reference:
// https://github.com/gpbl/react-day-picker/blob/master/src/Navbar.js


var DatePickerNavBar = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(DatePickerNavBar, _React$Component);

  function DatePickerNavBar() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _this.handleNextClick = function () {
      if (_this.props.onNextClick) {
        _this.props.onNextClick();
      }
    };

    _this.handlePreviousClick = function () {
      if (_this.props.onPreviousClick) {
        _this.props.onPreviousClick();
      }
    };

    _this.handleNextKeyDown = function (event) {
      if (event.keyCode !== ENTER && event.keyCode !== SPACE) {
        return;
      }

      event.preventDefault();

      _this.handleNextClick();
    };

    _this.handlePreviousKeyDown = function (event) {
      if (event.keyCode !== ENTER && event.keyCode !== SPACE) {
        return;
      }

      event.preventDefault();

      _this.handlePreviousClick();
    };

    return _this;
  }

  var _proto = DatePickerNavBar.prototype;

  _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    return nextProps.labels !== this.props.labels || nextProps.dir !== this.props.dir || this.props.showPreviousButton !== nextProps.showPreviousButton || this.props.showNextButton !== nextProps.showNextButton;
  };

  _proto.render = function render() {
    var _this$props = this.props,
        showPreviousButton = _this$props.showPreviousButton,
        showNextButton = _this$props.showNextButton,
        labels = _this$props.labels,
        dir = _this$props.dir;
    var previousClickHandler;
    var nextClickHandler;
    var previousKeyDownHandler;
    var nextKeyDownHandler;
    var shouldShowPrevious;
    var shouldShowNext;

    if (dir === "rtl") {
      previousClickHandler = this.handleNextClick;
      nextClickHandler = this.handlePreviousClick;
      previousKeyDownHandler = this.handleNextKeyDown;
      nextKeyDownHandler = this.handlePreviousKeyDown;
      shouldShowNext = showPreviousButton;
      shouldShowPrevious = showNextButton;
    } else {
      previousClickHandler = this.handlePreviousClick;
      nextClickHandler = this.handleNextClick;
      previousKeyDownHandler = this.handlePreviousKeyDown;
      nextKeyDownHandler = this.handleNextKeyDown;
      shouldShowNext = showNextButton;
      shouldShowPrevious = showPreviousButton;
    }

    var previousButton = ___EmotionJSX(NavButton, {
      tabIndex: 0,
      "aria-label": labels.previousMonth,
      key: "previous",
      onKeyDown: shouldShowPrevious ? previousKeyDownHandler : undefined,
      onClick: shouldShowPrevious ? previousClickHandler : undefined,
      disabled: !shouldShowPrevious
    }, ___EmotionJSX(NavLeftIcon, {
      size: "1em"
    }));

    var nextButton = ___EmotionJSX(NavButton, {
      tabIndex: 0,
      "aria-label": labels.nextMonth,
      key: "right",
      onKeyDown: shouldShowNext ? nextKeyDownHandler : undefined,
      onClick: shouldShowNext ? nextClickHandler : undefined,
      disabled: !shouldShowNext
    }, ___EmotionJSX(NavRightIcon, {
      size: "1em"
    }));

    return ___EmotionJSX(NavBar, null, dir === "rtl" ? [nextButton, previousButton] : [previousButton, nextButton]);
  };

  return DatePickerNavBar;
}(React.Component);

DatePickerNavBar.defaultProps = {
  showPreviousButton: true,
  showNextButton: true,
  onPreviousClick: undefined,
  onNextClick: undefined,
  dir: "ltr",
  labels: {
    previousMonth: "Previous Month",
    nextMonth: "Next Month"
  }
};
export { DatePickerNavBar as default };